import React from 'react';

import cypressIds from 'Components/cypress_ids.json';
import VrmModal from 'Components/pages/VehicleDetailsRedesign/Components/VrmModal/VrmModal';
import { VehicleSpecsDetailsButton } from 'Components/pages/VehicleDetailsRedesign/sections/MotSection/VehicleSpecsDetailsButton/VehicleSpecsDetailsButton';
import ListTable from 'Components/shared/ProTable/ListTable/ListTable';
import NewBadge from 'Storybook/local/NewBadge/NewBadge';
import type { ListTableValuesInterface } from 'Types/listTable';

interface DetailsLinkVrmModalListTableProps {
	badgeClassName: string;
	hasMultipleTableValues?: boolean;
	isNew?: boolean;
	makeModel: string;
	modalClassName?: string;
	modalEvents?: {} | (() => void);
	modalText?: {
		footer?: string | React.ReactNode;
		subtitle?: string | React.ReactNode;
		title?: string | React.ReactNode;
	};
	subtitle?: string | React.ReactNode;
	title?: string | React.ReactNode;
	values: ListTableValuesInterface[] | [];
	vrm: string;
}

export const DetailsLinkVrmModalListTable: React.FC<DetailsLinkVrmModalListTableProps> = ({
	badgeClassName,
	hasMultipleTableValues,
	isNew,
	makeModel,
	modalClassName,
	modalEvents = {},
	modalText = {},
	subtitle,
	title,
	values = [],
	vrm,
}) => (
	<>
		<VehicleSpecsDetailsButton
			{...modalEvents}
			cypressId={cypressIds.links.vrmModalDetails}
			modal={
				<VrmModal makeModel={makeModel} subtitle={subtitle} title={title} vrm={vrm} {...modalText}>
					<ListTable
						className={modalClassName}
						hasMultipleTableValues={hasMultipleTableValues}
						proTableParams={{ alternateRowHighlight: 'even' }}
						// @ts-ignore
						values={values}
					/>
				</VrmModal>
			}
		/>
		{isNew && <NewBadge wrapperClassName={badgeClassName} />}
	</>
);
